import service from '@/base/service'

const baseURL = process.env.VUE_APP_BASE_API_AI

const request = (data) => {
  return service({ ...data, ...{ baseURL } })
}

//  消息列表
export function messageList (data) {
      return request({
        url: '/vv5/msg/list',
        method: 'GET',
        params: data
      })
    }
// 更新消息为已读
// export function updateMessageRead (data) {
//       return request({
//         url: `/vv5/msg/read/${data.id}`,
//         method: 'PUT',
//         params: {}
//       })
//     }
    export function updateMessageRead (data) {
      return request({
        url: '/vv5/msg/read',
        method: 'PUT',
        params: {}
      })
    }

// 消息列表未读消息数量
export function messageNoRead (data) {
      return request({
        url: '/vv5/msg/unreadCount',
        method: 'GET',
        params: data
      })
    }